import clsx from "clsx";

interface SpeechMarkProps {
  /** How many notes. Left out for a single mark. */
  count?: number;
  /** Names the mark for screen readers. */
  label?: string;
  className?: string;
}

/**
 * A note is a small speech mark. It takes no state colour, because a note changes no state
 * (DEC-1016-82).
 */
export function SpeechMark({ count, label, className }: SpeechMarkProps) {
  const name = label ?? (count === undefined ? "Note" : count === 1 ? "1 note" : `${count} notes`);
  return (
    <span className={clsx("speech-mark", className)} role="img" aria-label={name} title={name}>
      <svg viewBox="0 0 20 18" width="18" height="16" aria-hidden="true" focusable="false">
        <path d="M3 1.5h14a1.5 1.5 0 0 1 1.5 1.5v8A1.5 1.5 0 0 1 17 12.5H9l-4.5 4v-4H3A1.5 1.5 0 0 1 1.5 11V3A1.5 1.5 0 0 1 3 1.5z" />
      </svg>
      {count !== undefined && count > 1 && <span className="speech-mark__count">{count}</span>}
    </span>
  );
}
